/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://bjzdekdcvzhivjky2gcbwvtdqe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-fwqsgswdvfcdnk44nf2n6p7tsa",
    "aws_cloud_logic_custom": [
        {
            "name": "uploadapi",
            "endpoint": "https://b6d4gp2bid.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:e9731a55-10b9-4a7d-81ae-918fba279064",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_uynEHxkJW",
    "aws_user_pools_web_client_id": "1707c3sjom93l2nbrovlaqokl",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "highlights-intake212911-main",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
